import React from "react";

const Centered: React.FC = ({ children }) => (
  <div className="centered">{children}</div>
);
export default Centered;
